import React, { useContext, useEffect, useState } from 'react'
import { Card, CardBody, Input, Table, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import { Link, withRouter } from 'react-router-dom'
import Moment from 'react-moment'
import toastr from 'toastr'

import ApiService from '../../../data/services/ApiService'
import { GeneralContext } from '../../../context/'
import ProgramarFacturaModal from './ProgramarFacturaModal'
import {
    cancelarProgramacionFactura,
    getProgramacionInicial,
    reintentarFacturaProgramada
} from '../../../helpers/facturasProgramadas'

const Programadas = (props) => {
    const { setLoading } = useContext(GeneralContext)
    const [facturas, setFacturas] = useState([])
    const [filteredFacturas, setFilteredFacturas] = useState([])
    const [facturaToSchedule, setFacturaToSchedule] = useState(null)

    useEffect(() => {
        ;(async () => {
            await loadFacturas()
        })()

        // eslint-disable-next-line
    }, [])

    const loadFacturas = async () => {
        try {
            setLoading(true)
            const response = await ApiService.getFacturasProgramadas()
            const data = response.data?.data?.facturas || []

            setFacturas(data)
            setFilteredFacturas(data)
        } catch (error) {
            toastr.error('No pude cargar las facturas programadas.')
        } finally {
            setLoading(false)
        }
    }

    const filterFacturas = (e) => {
        const keystroke = e.target.value.toLowerCase()
        const data = facturas.filter((factura) => {
            const receptor = factura.clientes?.[0]?.razonSocial || ''
            const interval = factura.schedule?.interval || ''
            const status = factura.status || ''

            return (
                receptor.toLowerCase().includes(keystroke) ||
                interval.toLowerCase().includes(keystroke) ||
                status.toLowerCase().includes(keystroke)
            )
        })

        setFilteredFacturas(data)
    }

    const onCancelarProgramacion = async (id) => {
        try {
            setLoading(true)
            const response = await cancelarProgramacionFactura(id)
            if (!response.data?.success) {
                toastr.error(response.data?.message || 'No pude cancelar la programación.')
                return
            }

            toastr.success('La factura volvió a borrador.')
            await loadFacturas()
        } catch (error) {
            toastr.error(error.response?.data?.message || 'No pude cancelar la programación.')
        } finally {
            setLoading(false)
        }
    }

    const onReintentar = async (id) => {
        try {
            setLoading(true)
            const response = await reintentarFacturaProgramada(id)
            if (!response.data?.success) {
                toastr.error(response.data?.message || 'No pude reintentar la factura.')
                return
            }

            toastr.success('La factura se volverá a intentar en la próxima ejecución.')
            await loadFacturas()
        } catch (error) {
            toastr.error(error.response?.data?.message || 'No pude reintentar la factura.')
        } finally {
            setLoading(false)
        }
    }

    const getStatusBadge = (status) => {
        if (status === 'programada') {
            return (
                <span style={{
                    backgroundColor: '#fff3cd',
                    color: '#856404',
                    border: '1px solid #ffc107',
                    borderRadius: 4,
                    padding: '4px 8px',
                    fontSize: '75%',
                    fontWeight: 600
                }}>
                    Programada
                </span>
            )
        }

        return (
            <span style={{
                backgroundColor: '#f8d7da',
                color: '#721c24',
                border: '1px solid #dc3545',
                borderRadius: 4,
                padding: '4px 8px',
                fontSize: '75%',
                fontWeight: 600
            }}>
                Fallida
            </span>
        )
    }

    return (
        <Card>
            <CardBody>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <Input
                        type="text"
                        placeholder="Buscar..."
                        style={{ maxWidth: 320 }}
                        onKeyUp={filterFacturas}
                    />
                    <Link to="/facturas" className="btn btn-light">
                        Volver a facturas
                    </Link>
                </div>

                <Table responsive striped>
                    <thead>
                        <tr>
                            <th>Receptor</th>
                            <th>Fecha programada</th>
                            <th>Recurrente</th>
                            <th>Intervalo</th>
                            <th>Status</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredFacturas.map((factura) => (
                            <React.Fragment key={factura._id}>
                                <tr>
                                    <td>{factura.clientes?.[0]?.razonSocial || 'Sin receptor'}</td>
                                    <td>
                                        <Moment format="DD/MM/YYYY HH:mm">
                                            {factura.schedule?.scheduledFor}
                                        </Moment>
                                    </td>
                                    <td>{factura.schedule?.isRecurring ? 'Sí' : 'No'}</td>
                                    <td>{factura.schedule?.interval || '-'}</td>
                                    <td>{getStatusBadge(factura.status)}</td>
                                    <td>
                                        <UncontrolledDropdown>
                                            <DropdownToggle href="#" className="card-drop" tag="i">
                                                <i className="mdi mdi-dots-horizontal font-size-18"></i>
                                            </DropdownToggle>
                                            <DropdownMenu right>
                                                <DropdownItem onClick={() => props.history.push(`/facturas/nueva/${factura._id}`)}>
                                                    <i className="mdi mdi-pencil font-size-16 text-primary mr-2"></i>
                                                    Editar factura
                                                </DropdownItem>
                                                <DropdownItem onClick={() => setFacturaToSchedule(factura)}>
                                                    <i className="mdi mdi-calendar-clock font-size-16 text-warning mr-2"></i>
                                                    Actualizar programación
                                                </DropdownItem>
                                                {factura.status === 'programada' && (
                                                    <DropdownItem onClick={() => onCancelarProgramacion(factura._id)}>
                                                        <i className="mdi mdi-cancel font-size-16 text-danger mr-2"></i>
                                                        Cancelar programación
                                                    </DropdownItem>
                                                )}
                                                {factura.status === 'fallida' && (
                                                    <DropdownItem onClick={() => onReintentar(factura._id)}>
                                                        <i className="mdi mdi-refresh font-size-16 text-danger mr-2"></i>
                                                        Reintentar
                                                    </DropdownItem>
                                                )}
                                            </DropdownMenu>
                                        </UncontrolledDropdown>
                                    </td>
                                </tr>
                                {factura.status === 'fallida' && factura.schedule?.errorReason && (
                                    <tr>
                                        <td colSpan="6" style={{ color: '#721c24', backgroundColor: '#fff5f5' }}>
                                            <strong>Motivo de falla:</strong> {factura.schedule.errorReason}
                                        </td>
                                    </tr>
                                )}
                            </React.Fragment>
                        ))}
                    </tbody>
                </Table>
            </CardBody>

            {facturaToSchedule && (
                <ProgramarFacturaModal
                    facturaId={facturaToSchedule._id}
                    isOpen={Boolean(facturaToSchedule)}
                    title="Actualizar programación"
                    submitLabel="Guardar cambios"
                    initialSchedule={getProgramacionInicial(facturaToSchedule)}
                    onRequestClose={() => setFacturaToSchedule(null)}
                    onSuccess={async () => {
                        setFacturaToSchedule(null)
                        await loadFacturas()
                    }}
                />
            )}
        </Card>
    )
}

export default withRouter(Programadas)
